


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class SideBarItem extends Vue {
  @Prop() public to!: string;
  @Prop({ default: null }) public perm: string;
  @Prop({ default: null }) public icon: string;
  @Prop({ default: null }) public svg: string;  
  @Prop({ default: 0 }) public indent: number;
  @Prop({ default: '#495057' }) public iconColor: string;
  @Prop({ default: null }) public parent: Components.SideBarGroup;
  @Prop({ default: null }) public title: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({ default: null }) public count: number;
   @Prop({ default: false }) public isFavoriteEditable:boolean; 
  public mounted() {
    if (this.parent != null) this.parent.apend(this);
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);    
  }

  public get indentChars(): string {
    let result = '';
    for (let i = 0; i < this.indent; i++) {
      result += '\u00a0';
    }
    return result;
  }
  public isActive() {
    if (this.to){
      //現在のフルパスにstaticが含まれる場合は、フルパスで検索、それ以外は、パスで検索。
      return this.$route.query.static ? this.to == this.$route.fullPath : this.to == this.$route.path;
    } else {
      return false;
    }
    //return this.to != null ? this.to == this.$route.fullPath : false;
  }

  public reset(e: any) {
    //ドラッグイベントと区別できないため、リロード処理を無効化
    
    // if (this.to == this.$route.fullPath) {
    //   //同一URLの場合リロードされないので先にフラグ付きでリロードしたうえで、後続する遷移イベントで上書きする形でリロードする
    //   const query = { ...this.$route.query, refresh: 1 };
    //   const newRoute = { ...this.$route, query };
    //   this.$router.replace(newRoute as any);
    // }
  }
  public collapse() {
    this.$emit('selected', this);
  }

  public onButtonClick() {
    this.$emit('buttonClicked', this);
  }
  // 案件管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenProjectItem:Array<string> = [
    "/sales/ProjectItem",
  ];
  // 在庫管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenNoStock: Array<string> = [
    "/master/SKU",
    "/master/Conversion",
    "/master/Assembly",
    "/master/Component",
    "/master/ShelfNo",
    "/sales/SalesCharge",
    "/sales/SalesPicking",
    "/purchase/PurchaseCharge",
    "/journal/StockBalance",
    "/journal/StockTaking",
    "/journal/StockTakingItem",
    "/journal/StockTransfer",
    "/journal/StockTransferItem",
    "/journal/StockRelocation",
    "/journal/StockRelocationItem",
    "/journal/StockReplenishmentCommodity",
  ];
  // 運用管理機能が無い場合のサイドボタン非表示のリスト
  public static hiddenNoOperation: Array<string> = [
    "/system/Group",
    "/system/GroupMember",
    "/system/Permission",
    "/system/Workflow",
    "/system/WorkflowAction",
    "/system/WorkflowPermission",
    // "/system/FileLayout",
    "/system/Topics",
    "/system/ECSetting",
    "/system/BatchSchedule",
    // "/system/PartneredTenant",
    // "/system/PartneredUser",
  ];
  
  public isShow() : boolean{
    if (Common.Api.siteMode == Common.siteModes.admin) return true;
    if (this.to){
      // 案件機能が無い場合
      if(this.$api.useProjectItemFunction == false)
      {
        if(SideBarItem.hiddenProjectItem.includes(this.to)) return false;
      }
      // 在庫機能が無い場合
      if(this.$api.useStockFunction == false)
      {
        if(SideBarItem.hiddenNoStock.includes(this.to)) return false;
      }
      // 運用管理機能が無い場合
      if(this.$api.useOperationFunction == false)
      {
        if(SideBarItem.hiddenNoOperation.includes(this.to)) return false;
      }
    }
    return true;
  }
}
